// extracted by mini-css-extract-plugin
export var divider = "_n5-0";
export var systemMessage = "_n5-1";
export var systemMessageWrapper = "_n5-2";